import * as React from 'react';
import { gql } from '@apollo/client';
import {
  useGetEmailNotificationSettingsLazyQuery,
  useUpdateEmailNotificationSettingsMutation,
  useUpdateUserSettingsMutation
} from '../../../models/graphql';
import { EmailNotificationController, EmailNotificationControllerProps } from './EmailNotification.controller';

export type EmailNotificationApolloProps = Omit<
  EmailNotificationControllerProps,
  | 'updateEmailNotification'
  | 'getEmailNotificationSettings'
  | 'getEmailNotificationSettingsResults'
  | 'updateUserSettings'
> & {
  // ...
};
gql`
  query GetEmailNotificationSettings($organizationId: ID!) {
    organization(organizationId: $organizationId) {
      id
      name
      settings {
        id
        productAnalyticsEnabled
        notifySubscriptionEnabled
      }
      myUserAssignment {
        id
        role
        settings {
          id
          dateFormat
          timeFormat
          notifyWeeklyStatsEnabled
          notifyQueueEmptyEnabled
          notifyPostProfileErrorEnabled
          notifyInstagramPostEnabled
          notifyAutoRssEnabled
        }
        user {
          id
          firstName
          email
        }
      }
    }
  }
  #  mutation UpdateEmailNotificationSettings($input: CombinedOrganizationSettingsInput!, $organizationId: ID!) {
  mutation UpdateEmailNotificationSettings(
    $input: CombinedOrganizationSettingsInput!
    $organizationId: ID!
    $userId: ID
  ) {
    #     organizationId: ID!, userId: ID = null, input: CombinedOrganizationSettingsInput
    updateOrganizationSettings(input: $input, organizationId: $organizationId, userId: $userId) {
      userOrganizationSettings {
        id
        timeFormat
        dateFormat
        notifyPostProfileErrorEnabled
        notifyWeeklyStatsEnabled
        notifyQueueEmptyEnabled
        notifyPostProfileErrorEnabled
        notifyInstagramPostEnabled
        notifyAutoRssEnabled
      }
      organizationSettings {
        id
        productAnalyticsEnabled
        notifySubscriptionEnabled
      }
    }
  }
  mutation UpdateUserSettings($userId: ID, $input: UserSettingsInput!) {
    updateUserSettings(userId: $userId, input: $input) {
      id
      onlineMarketing
      notifyFeatureAddedEnabled
      notifyMailingListEnabled
      notifyProductUpdatesEnabled
      notifyReferralCreditsEnabled
    }
  }
`;

export const EmailNotificationApollo = (props: EmailNotificationApolloProps): JSX.Element => {
  const [getEmailNotificationSettings, getEmailNotificationSettingsResults] =
    useGetEmailNotificationSettingsLazyQuery();

  const [updateEmailNotification] = useUpdateEmailNotificationSettingsMutation();

  const [updateUserSettings] = useUpdateUserSettingsMutation();

  const controllerProps: EmailNotificationControllerProps = {
    ...props,
    updateEmailNotification,
    getEmailNotificationSettingsResults,
    getEmailNotificationSettings,
    updateUserSettings
  };

  return <EmailNotificationController {...controllerProps} />;
};
